import { Injectable } from "@angular/core";
import { LinhaRota } from "@tivic-team/manager-ts/dist/mob/entities/linha/linha-rota.entity";
import { Linha } from "@tivic-team/manager-ts/dist/mob/entities/linha/linha.entity";
import { LinhaController } from "app/controllers/mob/linha.controller";
import { LinhaDTO, LinhaListDTO } from "app/model/dtos/mob/linha.dto";
import { TabelaHorarioDTO } from '../../model/dtos/mob/tabela-horario.dto';
import { LoaderService } from "../loader.service";
import { ApiService } from './../api-service.interface';
import { LinhaSearch } from "./linha.search";

@Injectable()
export class LinhaService implements ApiService<Linha>  {

    constructor(
        private _linhaController: LinhaController,
        private _loaderService: LoaderService
    ) { }

    find(search?: LinhaSearch): Promise<Linha[]> {
        this._loaderService.show();
        return this._linhaController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    findLinha(search?: LinhaSearch): Promise<Linha[]> {
        this._loaderService.show();
        return this._linhaController.findLinha(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    async findLinhas(linhaSearch?: LinhaSearch): Promise<LinhaListDTO> {
        this._loaderService.show();
        return await this._linhaController.findLinhas(linhaSearch && linhaSearch.getFilters() || null).finally(() => this._loaderService.hide())
    }

    async get(cdLinha: number): Promise<LinhaDTO> {
        this._loaderService.show();
        return this._linhaController.get(cdLinha).finally(() => this._loaderService.hide());
    }
    
    save(entity: Linha): Promise<Linha> {
        if (!entity.cdLinha)
            return this.create(entity);
        return this.update(entity);
    }

    create(entity: Linha): Promise<Linha> {
        this._loaderService.show();
        return this._linhaController.create(entity).finally(() => this._loaderService.hide());
    }
    
    update(entity: Linha): Promise<Linha> {
        this._loaderService.show();
        return this._linhaController.update(entity).finally(() => this._loaderService.hide());
    }

    saveLinhaRural(entity: Linha): Promise<Linha> {
        if (!entity.cdLinha)
            return this.createLinhaRural(entity);
        return this.updateLinhaRural(entity);
    }

    createLinhaRural(entity: Linha): Promise<Linha> {
        this._loaderService.show();
        return this._linhaController.createLinhaRural(entity).finally(() => this._loaderService.hide());
    }
    updateLinhaRural(entity: Linha): Promise<Linha> {
        this._loaderService.show();
        return this._linhaController.updateLinhaRural(entity).finally(() => this._loaderService.hide());
    }

    async getRotas(cdLinha: number): Promise<LinhaRota[]> {
        try {
            return await this._linhaController.getRotas(cdLinha);
        }
        catch (error) {
            console.error(error);
        }
    }

    async getTabelas(cdLinha: number, cdTabelaHorario: number): Promise<TabelaHorarioDTO> {
        try {
            return await this._linhaController.getTabelas(cdLinha, cdTabelaHorario);
        }
        catch (error) {
            console.error(error);
        }
    }

    getRelatorioItinerario(linhaSearch?: LinhaSearch): Promise<Blob> {
        this._loaderService.show();
        return this._linhaController.getRelatorioItinerario((linhaSearch && linhaSearch.getFilters()) || null).finally(() => this._loaderService.hide());
    }
}